import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { buttonReset } from "../../util/styles.js";

export const StyledHeader = styled.header`
  background-color: #fff;
  color: var(--swatch2);
  .button--primary {
    background-color: color-mix(in srgb, var(--swatch1) 10%, #fff);
  }
`;

export const Constrainer = styled.div`
  margin: 0 auto;
  max-width: 1100px;
`;

export const TopOuter = styled.div`
  padding: ${(props) => props.theme.spacing.m} 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

export const TopInner = styled.div<{}>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${mobileBreakPointCSS}) {
    justify-content: center;

    > * {
      flex: 1;
    }

    > *:last-child {
      display: flex;
      justify-content: flex-end;
    }

    > a {
      display: flex;
    }

    .secondary-logo {
      display: inline-block;
    }
  }
`;

export const Logo = styled.img`
  display: block;
  height: 50px;
`;

export const SecondaryLogo = styled.img`
  display: block;
  height: 28px;
  margin-right: auto;
`;

export const MobileSecondaryLogo = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${(props) => props.theme.spacing.l};
  height: 28px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  a {
    display: block;
    height: 16px;

    img {
      height: 16px;
      width: auto;
    }
  }

  > img {
    height: 16px;
    width: auto;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    display: none;
  }
`;

export const IconMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -14px;

  button {
    ${buttonReset};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    height: 48px;
    width: 48px;
    padding: 0 14px;

    svg {
      height: 20px;

      line {
        stroke: var(--swatch2);
      }

      path {
        fill: var(--swatch2);
      }
    }
  }
`;

export const BottomOuter = styled.div`
  padding: ${(props) => props.theme.spacing.s} 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => props.theme.spacing.m} 0;
  }
`;

export const MobileMenu = styled(BottomOuter)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  overflow-y: auto;
  overscroll-behavior: contain;
  background-color: var(--header-mobile-menu-background, #fff);
`;

export const SearchWrapper = styled.div<{ $minimized: boolean }>`
  position: relative;
  display: flex;
  justify-content: flex-end;

  input {
    border-radius: ${(props) => props.theme.borderRadius};
    width: 100%;
    box-sizing: border-box;
    padding-right: 50px;
    transition: width 0.12s ease-in-out;
  }

  svg {
    position: absolute;
    top: 12px;
    right: ${(props) => props.theme.spacing.m};
    width: 16px;
    height: 16px;
    pointer-events: none;

    path {
      fill: var(--swatch2);
    }
  }

  ${(props) =>
    props.$minimized &&
    css`
      input {
        width: 114px;
      }
    `}
`;

export const PrimaryAction = styled.div`
  text-align: center;
  margin-top: ${(props) => props.theme.spacing.m};
  margin-bottom: ${(props) => props.theme.spacing.xs};
`;

export const MiniMenuTopWrapper = styled.div`
  width: 100%;
  background-color: var(--swatch3);
`;

export const MiniMenuTop = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--swatch3);
  justify-content: right;
  height: 40px;

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      &:last-child {
        padding-left: ${(props) => props.theme.spacing.s};
      }

      &:first-child {
        padding-right: ${(props) => props.theme.spacing.s};
      }

      &:not(:last-child) {
        padding: 0 ${(props) => props.theme.spacing.s};
        border-right: 1px solid var(--swatch2);
      }

      a {
        display: block;
        color: var(--swatch2);
        text-decoration: none;
        font-size: 0.875rem;

        span {
          font-weight: bold;
        }
      }
    }
  }
`;
